<ng-container *ngIf="imagePath; else imagePlaceholder">
  <img class="table-image" [src]="imagePath" alt="" />
</ng-container>

<ng-template #imagePlaceholder>
  <img class="table-image" src="assets/images/logoauth.png" alt="" />
</ng-template>
